<template>
  <v-combobox
    v-model="selected"
    :item-value="itemValue"
    :item-text="itemText"
    :items="options"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :error-messages="error"
    @change="change($event)"
    ref="input"
  />
</template>

<script>
export default {
  name: 'OrganizationCombobox',
  emits: ['input'],
  $_veeValidate: {
    name () {
      return this.label
    },
    value () {
      return this.selectedOrganization
    }
  },
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    itemText: {
      type: String,
      default: 'name'
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      selected: { id: 0, name: this.getExpression('Alert', 'NoOrganization'), createDate: null },
      noSelection: { id: 0, name: this.getExpression('Alert', 'NoOrganization'), createDate: null }
    }
  },
  computed: {
    selectedId () {
      return this.value
    }
  },
  methods: {
    change (e) {
      this.$emit('input', e.id)
    },
    
    setValue () {
      const self = this
      const organizations = this.options.filter(o => o.id === self.selectedId)
      self.selected = organizations.length > 0
        ? organizations[0]
        : self.placeholder != null
          ? null
          : self.noSelection
    },

    focus () {
      this.$refs.input.focus()
    }

  },
  created() {
    this.setValue()
  },
  watch: {
    selectedId () {
      this.setValue()
    }
  }
}
</script>